import { Divider } from '../../Divider'
import { useSelectContext } from '../Select.hooks'
import { SelectDropdownListSearchInput } from '../SelectDropdownListSearchInput'
import { SelectDropdownListSelectAllOption } from '../SelectDropdownListSelectAllOption'

import * as styles from './SelectDropdownListHeader.module.css'

function SelectDropdownListHeader({
  Element = 'div',
  Search = SelectDropdownListSearchInput,
  SelectAll = SelectDropdownListSelectAllOption,
  className = styles.SelectDropdownListHeader,
  disabled,
  searchProps,
  selectAllProps,
}) {
  const { multi } = useSelectContext()

  return (
    <Element className={className}>
      {Search ? <Search {...searchProps} disabled={disabled} /> : null}
      {SelectAll && multi ? (
        <>
          <SelectAll {...selectAllProps} disabled={disabled} />
          <Divider className={styles.divider} />
        </>
      ) : null}
    </Element>
  )
}

export default SelectDropdownListHeader
